const rankingItems = [
  { rank: 1, title: '暗夜追踪', type: '动作 / 悬疑', score: '9.6', trend: 'up', tag: 'NEW', views: '128万' },
  { rank: 2, title: '星河战纪·第三季', type: '科幻 / 冒险', score: '9.4', trend: 'up', tag: '热播', views: '96万' },
  { rank: 3, title: '都市寓言', type: '剧情 / 爱情', score: '9.3', trend: 'stable', tag: '', views: '85万' },
  { rank: 4, title: '迷雾深渊', type: '悬疑 / 犯罪', score: '9.1', trend: 'up', tag: '推荐', views: '73万' },
  { rank: 5, title: '长安风云录', type: '古装 / 历史', score: '8.9', trend: 'down', tag: '', views: '67万' },
  { rank: 6, title: '笑闹江湖', type: '喜剧 / 动作', score: '8.7', trend: 'up', tag: '', views: '59万' },
  { rank: 7, title: '深海异兽', type: '科幻 / 恐怖', score: '8.5', trend: 'stable', tag: '4K', views: '52万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">实时榜单</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">热度排行 · 人气之选</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">基于全网观看热度与用户评分实时更新，发现大家都在看的好片</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2 md:space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-bold text-sm md:text-base flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-semibold text-sm md:text-base text-foreground-900 truncate whitespace-nowrap">{item.title}</h3>
                  {item.tag && (
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-primary-100 text-primary-600 whitespace-nowrap">{item.tag}</span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{item.type}</p>
              </div>

              <div className="flex items-center gap-3 md:gap-5 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.views}</span>
                <span className="font-bold text-sm md:text-base text-accent-600 font-heading whitespace-nowrap">{item.score}</span>
                <span className={`w-4 h-4 flex items-center justify-center ${
                  item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-secondary-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-sm"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-sm"></i>}
                  {item.trend === 'stable' && <i className="ri-arrow-right-line text-sm"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}